import React from 'react';
const FullMessage = () => {
  return (
    <div className="info-container">
      <h1>This event is already full</h1>
      <p>
        Unfortunately, the maximum number of users have already joined this
        showing.
      </p>
      <p>
        Either ask your host to upgrade their account, or wait until a space
        becomes available and refresh this page.
      </p>
    </div>
  );
};

export default FullMessage;
